import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from '@material-ui/core';
import { useRadioOptionsStyles } from './styles';
import { CHOOSE_OPTION } from '../../../constants/texts';

const RadioOptions = ({ ...props }) => {
  const { options, mobile, onChange, motiveClient } = props;
  const classes = useRadioOptionsStyles({ mobile });

  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <React.Fragment>
      <Typography className={classes.title}>{CHOOSE_OPTION}</Typography>

      <RadioGroup onChange={handleChange} value={motiveClient}>
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option.value}
            label={option.value}
            name={option.name}
            control={<Radio color="primary" />}
            className={classes.radioButton}
            data-cy={`radio${option.value.split(' ').join('')}`}
          />
        ))}
      </RadioGroup>

      <Divider className={classes.divider} />
    </React.Fragment>
  );
};

RadioOptions.propTypes = {
  options: PropTypes.array,
  mobile: PropTypes.bool,
  onChange: PropTypes.func,
  motiveClient: PropTypes.string,
};

export default RadioOptions;
